import { createIdbAuthStorage } from './auth.idb';

/**
 * Pluggable persistence for AuthManager.
 * Default is IndexedDB. Cap apps may call configureAuthStorage() before
 * importing @api-client/auth/auth so Preferences (or another backend) is used.
 */
export type AuthStorage<T> = {
    load: () => Promise<T>;
    save: (state: T) => Promise<void>;
    clear: () => Promise<void>;
};

export type AuthStorageFactory = <T extends { accessToken: string | null }>(
    emptyState: T
) => AuthStorage<T>;

let authStorageFactory: AuthStorageFactory = createIdbAuthStorage;
let authManagerConstructed = false;

/** Mark that AuthManager has been constructed — further configureAuthStorage is ignored. */
export function markAuthManagerConstructed() {
    authManagerConstructed = true;
}

/**
 * Swap the storage backend. Must run before AuthManager is constructed
 * (i.e. before any import of @api-client/auth/auth).
 */
export function configureAuthStorage(factory: AuthStorageFactory) {
    if (authManagerConstructed) {
        console.warn(
            '[auth] configureAuthStorage() called after AuthManager was constructed — ignored'
        );
        return;
    }
    authStorageFactory = factory;
}

export function getAuthStorageFactory(): AuthStorageFactory {
    return authStorageFactory;
}
